import React from 'react';
import { GraduationCapIcon, HeartHandshakeIcon, SchoolIcon, TrophyIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { audiences } from '../data/content';
const icons = {
  volunteer: HeartHandshakeIcon,
  club: TrophyIcon,
  pe: GraduationCapIcon,
  school: SchoolIcon
};
export function WhoItsFor() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-190" data-mp="1ad6e7hriayh5">
      <div className="mx-auto w-full max-w-5xl" data-id="element-191" data-mp="dnz1mz8v7zpd">
        <Reveal data-id="element-192" data-mp="dpa5ez2b97gh">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-193" data-mp="dlmca10s2n2a">
            Made for <span className="text-brand-strong" data-id="element-194" data-mp="modmjxhx3csc">every flag football coach</span>
          </h2>
        </Reveal>

        <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-195" data-mp="rf3v1jln3vr9">
          {audiences.map((audience, index) => {
          const Icon = icons[audience.icon as keyof typeof icons];
          return <Reveal key={audience.title} delay={index * 0.04} className="h-full" data-id="element-196" data-mp="3v2m8wntuj7c2" data-mpi={index}>
                <li className="flex h-full items-center gap-4 rounded-card bg-tint p-5 lg:flex-col lg:items-start lg:p-6" data-id="element-197" data-mp="1zonkaehsnbz9">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white" data-id="element-198" data-mp="1von2qkzeeknz">
                    <Icon className="h-5 w-5 text-turf" aria-hidden="true" data-id="element-199" data-mp="1qvahmktxgvzz" />
                  </span>
                  <span className="font-display text-base font-bold leading-snug text-navy" data-id="element-200" data-mp="1lw7o9xnb8e7u">
                    {audience.title}
                  </span>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}